/* __next_internal_client_entry_do_not_use__ useCollectionTileViewImpression auto */ // eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { usePairedIntersectionObserver } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/ProductTileViewImpressionContext";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useUnmountProductTileContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/UnmountProductTileContext";
import { useEffect } from "react";
export var useCollectionTileViewImpression = function(param) {
    var _param_collectionToken = param.collectionToken, collectionToken = _param_collectionToken === void 0 ? "" : _param_collectionToken, _param_brandPromoToken = param.brandPromoToken, brandPromoToken = _param_brandPromoToken === void 0 ? "" : _param_brandPromoToken;
    var handleIntersectionObserverCallbackRef = usePairedIntersectionObserver();
    var onUnmount = useUnmountProductTileContext().onUnmount;
    useEffect(function() {
        return function() {
            onUnmount(collectionToken, "");
        };
    }, [
        collectionToken,
        onUnmount
    ]);
    return {
        ref: handleIntersectionObserverCallbackRef,
        "data-collection-token": collectionToken,
        "data-brand-promo-token": brandPromoToken
    };
};
